import {IconButton, MenuItem, Paper} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {Scope} from 'Shared/constants/Scope';
import {removeUserType, changeMessagingRole} from 'Users/ducks/userEntry';
import {Application} from 'Users/models/Application';
import {MessagingRole, InvalidMessagingUserType, ValidMessagingUserType} from 'Users/models/User/MessagingUserType';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './MessagingUserTypeEntry.sass';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';

type MessagingUserTypeEntryProps = {
  messagingUserType: InvalidMessagingUserType | ValidMessagingUserType;
  isEdit: boolean;
};

const MessagingUserTypeEntry = (props: MessagingUserTypeEntryProps) => {
  const dispatch = useDispatch();
  const {messagingUserType} = props;
  const {messagingRole} = messagingUserType.value;

  const scopes = useSelector(selectUserScopes);
  const hasUpdateAccess = hasAccessToScopeByApplication(scopes, Scope.UpdateUser, Application.Messaging);

  return (
    <Paper className="messaging-user-type-entry">
      <IconButton
        className="messaging-user-type-entry__remove-button"
        onClick={() => dispatch(removeUserType(messagingUserType))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <Close />
      </IconButton>
      <p className="messaging-user-type-entry__title">Add Messaging Permissions</p>
      <p className="messaging-user-type-entry__description">
        Select a role and complete the appropriate fields to add messaging permissions to this user.
      </p>
      <OutlinedSelect
        className="messaging-user-type-entry__role-select"
        label="Messaging Role"
        value={messagingRole || ''}
        onChange={e => dispatch(changeMessagingRole(parseInt(e.target.value, 10) as MessagingRole))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <MenuItem value={MessagingRole.Admin}>Admin</MenuItem>
        <MenuItem value={MessagingRole.Manager}>Manager</MenuItem>
        <MenuItem value={MessagingRole.MessageSender}>Message Sender</MenuItem>
        <MenuItem value={MessagingRole.MessageAnalyst}>Message Analyst</MenuItem>
      </OutlinedSelect>
    </Paper>
  );
};

export default MessagingUserTypeEntry;
